
export const ACCOUNT_SAVED_FIELDS = [
  'id',
  'name',
  'responsible_name',
  'phone',
  'address',
  'uf',
  'city_code',
  'business_area',
  'metadata',
  'account_id',
  'subscription_type',
  'account_type',
  'step',
  'subscription_notice_mode',
  'subscription_notice_end_date'
]

const CONTRACT_COLUMNS = {
  start_date: 'subscription_start',
  end_date: 'subscription_expiration_date',
  renewal_mode: 'contract_renewal_mode'
}

export function toPlainAccount(model) {
  if (!model)
    return {}

  return JSON.parse(JSON.stringify(model))
}

export function contractPayload(account) {
  const document = account.contract_document

  if (!document)
    return {}

  return Object.keys(CONTRACT_COLUMNS).reduce((payload, key) => {
    payload[CONTRACT_COLUMNS[key]] = document[key] === undefined ? null : document[key]

    return payload
  }, {})
}

export function buildSavePayload(account) {
  const payload = ACCOUNT_SAVED_FIELDS.reduce((data, field) => {
    if (account[field] !== undefined)
      data[field] = account[field]

    return data
  }, {})

  return { ...payload, ...contractPayload(account) }
}

export default { ACCOUNT_SAVED_FIELDS, buildSavePayload, contractPayload, toPlainAccount }
